// extracted by mini-css-extract-plugin
export default {"container":"ProductsStateBox_container__ZDG33","productsCount":"ProductsStateBox_productsCount__y-mDF","percentage":"ProductsStateBox_percentage__yLN1H"};